import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { getToken } from "../../utils/getToken";

export const useGetLatestOrdersQuery = () => {
  const token = getToken();

  return useQuery({
    queryKey: ["useGetLatestOrdersQuery"],
    queryFn: () =>
      axiosInstance
        .get("dashboard/new-orders", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => res.data),

    enabled: !!token,
  });
};
